import { ivrOutcome } from '../../utils/ivrOutcome';

const PROCESSED_STATUSES = new Set(['covered', 'not_covered', 'approved']);

export function isProcessedIvr(record) {
  return PROCESSED_STATUSES.has(record?.status);
}

// Legacy rejected records without status policy version 2 still map to needs_review. The historical
// pending status also remains actionable so older records cannot be stranded without controls.
export function isActionableIvr(record) {
  if (!record) return false;
  const outcome = ivrOutcome(record);
  return record.status === 'pending' || record.status === 'submitted' || outcome === 'needs_review';
}
